/**
 * An RxJS subject that represents an async action with a result that can fail.
 */
import { ReplaySubject } from "rxjs";
import { scan } from "rxjs/operators";
/**
 * Redux-like action creators.
 * @returns
 */
const createAsyncActions = () => ({
    /**
     * Creates an action that's dispatched when loading starts.
     * @returns
     */
    asyncStart: () => ({
        type: "LOADING",
    }),
    /**
     * Createes an action that's dispatched when loading completes.
     * @param data
     * @returns
     */
    asyncSuccess: (data) => ({
        type: "LOADING_FINISH",
        data,
    }),
    /**
     * Creates an action that's dispatched when loading has an error.
     * @param error
     * @returns
     */
    asyncError: (error) => ({
        type: "LOADING_ERROR",
        error,
    }),
});
/**
 * Factory function for creating an AsyncSubject.
 * @returns
 */
export const createAsyncSubject = () => {
    const actions = createAsyncActions();
    const subject = new ReplaySubject();
    const state = subject.pipe(scan((state, action) => {
        switch (action.type) {
            case "LOADING":
                return Object.assign(Object.assign({}, state), { data: undefined, loading: true });
            case "LOADING_FINISH":
                return Object.assign(Object.assign({}, state), { loading: false, data: action.data });
            case "LOADING_ERROR":
                return Object.assign(Object.assign({}, state), { loading: false, error: action.error });
            default:
                return state;
        }
    }, { loading: false }));
    return {
        loadingStart: () => {
            subject.next(actions.asyncStart());
        },
        loadingSuccess: (data) => subject.next(actions.asyncSuccess(data)),
        loadingError: (error) => subject.next(actions.asyncError(error)),
        state,
    };
};
//# sourceMappingURL=AsyncSubject.js.map